export const switchPlanFormStyles = {
  descriptionStyle: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  summaryBox: {
    backgroundColor: "#f4f7fa",
    width: "100%",
    height: "100%",
  },
  separatorBullet: {
    fontSize: "10px",
  },
};
